"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrCreateGroupByName = void 0;
const api_1 = require("../_generated/client/api");
async function getOrCreateGroupByName(access, internalGroupName) {
    const groupsApi = new api_1.GroupsApi(await access());
    const result = await groupsApi.getGroups();
    if (result.status === 404) {
        return groupsApi
            .createGroup({
            internalName: internalGroupName,
            name: internalGroupName,
        })
            .then((q) => q.data);
    }
    const group = result.data.find((q) => q.resource.internalName === internalGroupName);
    if (!group) {
        return groupsApi
            .createGroup({
            internalName: internalGroupName,
            name: internalGroupName,
        })
            .then((q) => q.data);
    }
    return group;
}
exports.getOrCreateGroupByName = getOrCreateGroupByName;
